import { render, staticRenderFns } from "./TabbedViewTab.vue?vue&type=template&id=45f39bd4"
import script from "./TabbedViewTab.vue?vue&type=script&lang=js"
export * from "./TabbedViewTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports